export const mockUser = {
  firstName: "Marie",
  lastName: "Dupont",
  email: "marie.dupont@gmail.com",
  phone: "+33 6 12 34 56 78",
  memberSince: "Mars 2023",
  avatar: "MD",
  totalTickets: 87,
  totalDraws: 6,
  totalSpent: 415,
  notifications: true,
};

export const mockActiveTickets = [
  { id: "THV-52-0041823", draw: 52, package: "Classique", date: "2025-02-18", status: "active" },
  { id: "THV-52-0041824", draw: 52, package: "Classique", date: "2025-02-18", status: "active" },
  { id: "THV-52-0041825", draw: 52, package: "Classique", date: "2025-02-18", status: "active" },
  { id: "THV-52-0071204", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071205", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071206", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071207", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071208", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071209", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071210", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071211", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0071212", draw: 52, package: "Premium", date: "2025-03-01", status: "active" },
  { id: "THV-52-0095301", draw: 52, package: "Gold", date: "2025-03-10", status: "active" },
  { id: "THV-52-0095302", draw: 52, package: "Gold", date: "2025-03-10", status: "active" },
  { id: "THV-52-0095303", draw: 52, package: "Gold", date: "2025-03-10", status: "active" },
];

export const mockPurchaseHistory = [
  {
    id: "ORD-2025-0312",
    date: "10 Mars 2025",
    package: "Gold",
    tickets: 80,
    amount: 220,
    draw: 52,
    status: "active",
    statusLabel: "Tirage en cours",
  },
  {
    id: "ORD-2025-0189",
    date: "01 Mars 2025",
    package: "Premium",
    tickets: 43,
    amount: 130,
    draw: 52,
    status: "active",
    statusLabel: "Tirage en cours",
  },
  {
    id: "ORD-2025-0054",
    date: "18 Fév 2025",
    package: "Classique",
    tickets: 17,
    amount: 65,
    draw: 52,
    status: "active",
    statusLabel: "Tirage en cours",
  },
  {
    id: "ORD-2024-1842",
    date: "15 Jan 2025",
    package: "Premium",
    tickets: 43,
    amount: 130,
    draw: 51,
    status: "lost",
    statusLabel: "Non gagné",
  },
  {
    id: "ORD-2024-1420",
    date: "10 Déc 2024",
    package: "Classique",
    tickets: 17,
    amount: 65,
    draw: 50,
    status: "lost",
    statusLabel: "Non gagné",
  },
  {
    id: "ORD-2024-0980",
    date: "12 Nov 2024",
    package: "Starter",
    tickets: 5,
    amount: 25,
    draw: 49,
    status: "lost",
    statusLabel: "Non gagné",
  },
];

export const mockDrawProgress = {
  drawNumber: 52,
  drawDate: "2025-04-15T20:00:00",
  ticketsSold: 14382,
  ticketsTotal: 15000,
  myTicketsCount: 15,
  myWinProbability: 0.10,
  phase: "selling",
};

export const mockNotifications = [
  {
    id: 1,
    type: "success",
    icon: "ri-checkbox-circle-line",
    color: "text-emerald-500",
    bg: "bg-emerald-50",
    title: "Tickets reçus",
    message: "Votre commande Gold (80 tickets) a bien été confirmée.",
    date: "Il y a 10 jours",
    read: false,
  },
  {
    id: 2,
    type: "info",
    icon: "ri-timer-line",
    color: "text-sky-500",
    bg: "bg-sky-50",
    title: "Tirage dans 26 jours",
    message: "Le tirage #52 approche ! Achetez des tickets supplémentaires pour maximiser vos chances.",
    date: "Il y a 2 jours",
    read: false,
  },
  {
    id: 3,
    type: "info",
    icon: "ri-trophy-line",
    color: "text-amber-500",
    bg: "bg-amber-50",
    title: "Résultats tirage #51",
    message: "Le numéro gagnant du tirage #51 était #38420. Consultez les résultats complets.",
    date: "Il y a 2 mois",
    read: true,
  },
];
